<script context="module">
	import { writable } from 'svelte/store'
	//modal windows

	export const modalInfoContact = writable(false)
	export const modalInfoMaillist = writable(false)
	export const modalInfoBooking = writable(false)
	export const modalInfoAdmin = writable(false)
	export const modalInfoWhatsapp = writable(false)
	export const modalInfoCoverslider = writable(false)
	export const modalInfoGallery = writable(false)
	export const modalInfoPricing = writable(false)
	export const modalInfoStorage = writable(false)
	export const modalInfoBusiness = writable(false)
	export const modalLogin = writable(false)
	export const modalTUPLogin = writable(false)
	export const modalSendQuote = writable(false)
	export const modalCreateTextfile = writable(false)

	// variable for session storage
	export const storeStorage = writable(false)

	//the selected value from selector
	export const storeProdSelected = writable('')

	//on mount -> variables to set navigation active
	export const storeNavigation = writable('')

	//the total with currency
	export const storeTotal = writable('0')

	//the total is loaded
	export const storeTotalLoaded = writable(true)

	//the admin
	export const storeSiteAdmin = writable(false)

	//the login link
	export const storeLoginlink = writable('login')

	//the uploaded bytes
	export const storeRemainingStorage = writable(0)

	//the file list to upload
	export const storeFileList = writable([])

	//the alter file list to upload
	export const storeAlterFilelist = writable([])

	//the file-create handler
	export const storeCreateFileHandler = writable(false)

	//the sticky admin widgets
	export const storeAdminWidgets = writable([])

	//the active block
	export const storeActiveBlock = writable(null)

	//reload finished blocks
	export const storeFinishedContent = writable(null)

	//show finished blocks
	export const storeShowFinishedBlocks = writable(true)

	//uploader
	export const storeUploader = writable(false)

	//show-hide update pages
	export const storeUpdate = writable(null)
	export const storeUpdateContact = writable(null)
	export const storeUpdateSingle = writable(false)

	//delete block (set to change new_content in utils.js)
	export const storeDeleteBlock = writable(false)

	// the create content button (show-hide if isUpdate)
	// must be seperate from storeUpdate to prevent error if content of column is deleted!!
	export const storeShowCreateButtons = writable(true)

	//the create block buttons
	export const storeShowSliderButton = writable(false)
	export const storeShowGallery = writable(false)
	export const storeShowGalleryButton = writable(false)
	export const storeLogo = writable(true)

	//expandable slider
	export const storeExpand = writable(false)

	// singleImageBlock
	export const storeSingleImageBlock = writable(false)

	//builder
	export const storeData = writable()
	export const storeElementID = writable('--')
	export const storeSelectedTool = writable('--')
	export const storeShowTools = writable(false)
	export const storeSiteManagement = writable(false)
	export const storeBuilderPreview = writable(false)
	export const storeSelectedIcon = writable(false)
	export const storeContactForm = writable(false)

	//the image modal
	export const storeImageModal = writable(false)

	//templates
	export const storeBlockTemplate = writable(false)
	export const storeImageTemplate = writable(false)
	export const storeColumnTemplate = writable(false)

	//animation
	export const storeAnimate = writable('true')

	//logo dropper window
	export const storeLogoDropper = writable(false)

	//gallery & contact (if window is open wait for close to prevent error in "close builder" of nav)
	export const storeContact = writable(false)

	//restaurant, guest house, shop
	export const storeRooms = writable(true)
	export const storeShowRoomDetail = writable(false)
	export const storeRoomConfirm = writable(false)
	export const storeDrinks = writable(true)
	export const storeBooking = writable(false)
	export const storeFoods = writable(true)
	export const storeShop = writable(true)
	export const storeShowItem = writable(false)
	export const storeFreeRooms = writable([])

	//the menu (drinks & foods)
	export const storeShowBooking = writable(false)
	export const storeShowDrinks = writable(false)
	export const storeShowFoods = writable(false)
	export const storeShowRooms = writable(false)

	//mail addressing
	export const storeShowMail = writable(false)

	//for the book-keeping
	export const storeOldBookings = writable([])

	//for the mail images
	export const storeMailImages = writable(false)

	//check box for linked blocks
	export const storeIsLinked = writable(false)

	// show social media
	export const storeSocial = writable(true)

	// the linked site
	export const storeLinked = writable(false)

	// the links one for each column
	export const storeRedirect1 = writable(null)
	export const storeRedirect2 = writable(null)
	export const storeRedirect3 = writable(null)
	export const storeRedirect4 = writable(null)

	// the linked object for LinkedSite.svelte
	export const storeSite = writable(false)

	// hamburger icon
	export const storeHM = writable(false)

	// used colors
	export const storeUsedColors = writable([])

	// send feedback
	export const storeFeedback = writable(false)
</script>
